// IMPORTANTE
// Para que este utils funcione en mobile, se debe buildear para que se convierta en ".js"
// En VSCode: Ctrl + Shift + P, buscar la opción "Task: Run build task", y ejecutarla, con sólo hacer eso alcanza
// Luego commitear los resultados de el buld (se modifica utils.js)
import type { Queue } from './types/queue.type'
import type { Router } from './types/router.type'
import type { CSSProperties, Ref } from 'vue'
const moduleExport = {
  getWidgetHeight,
  getFontSize,
  setFont,
  getWidgetPadding,
  setStoredData,
  getStoredData,
  localUrlToStatic,
  urlToStatic,
  runningOnPlayer,
  externalUrl,
  formatColorLinks,
  getWebViewVersion,
  resolveAnnounceSound,
  getBrandIdentity,
  applyBrandIdentity,
  isBrandIdentityWidget
}

export const SCROLL_DELAY: number = 3 // Delay en segundos para el autoscroll de los textos
export const PAGE_DURATION: number = 10 // Duración por defecto de una página en segundos

// Types
// TODO: No se si esta es la forma de exportar tipos
type eventSubscriptionFunction = (event: string, fn: WidgetEventFunction) => void
type WidgetEventSuscriptor = { event: string, fn: WidgetEventFunction }

export class WidgetEventHandler {
  private suscriptors: WidgetEventSuscriptor[] = []
  constructor() { }


  suscribe(event: string, fn: WidgetEventFunction): void {
    this.suscriptors.push({ event, fn })
  }
  unsuscribe(event: string, fn: WidgetEventFunction): void {
    this.suscriptors = this.suscriptors.filter(f => f.event !== event || f.fn !== fn)
  }
  emit(event: string, data: any): void {
    this.suscriptors.forEach(f => {
      if (f.event === event) f.fn(data)
    })
  }
}

export type WidgetResizeEventData = {
  width: number,
  height: number
}

export type DatasetListener = {
  event: string,
  dataset: any,
  fn: WidgetEventFunction
}

export type SocketListener = {
  event: string,
  fn: WidgetSocketFunction
}

export type WidgetWrapper<Config, Item> = {
  getConfig: WidgetGetterFunction<Config>
  getData?: WidgetGetterFunction<Item[]> | WidgetGetterFunction<{}> | null,
  eventMethods?: {
    suscribe: eventSubscriptionFunction
    unsuscribe: eventSubscriptionFunction
  }
  datasetListeners?: DatasetListener[],
  totemSocketListeners?: SocketListener[],
  eventHandler?: WidgetEventHandler
}
export type WidgetGetterFunction<T> = (...args: any[]) => Promise<T>
export type WidgetEventFunction = (data: any) => void | Promise<void>
export type WidgetSocketFunction = (data: any) => void | Promise<void>
export type AdditionalMedia = [{ mediaType: string, _id: string, reference: any, mediaPath: string, name: string }]
export type DesignElement = {
  additionalMedia: AdditionalMedia,
  _type: string,
  designId: string,
  widgetConfig: {
    config: {
      widgetRss: RssWidgetConfig,
      widgetNews: NewsWidgetConfig,
      widgetUsers: UsersWidgetConfig,
      widgetSeniority: UsersWidgetConfig,
      widgetEntrance: UsersWidgetConfig,
      widgetClock: WidgetClockConfig,
      widgetInteractive: WidgetInteractiveConfig,
      widgetUrl: WidgetUrlConfig
      widgetTotem: WidgetTotemConfig
      widgetWeather: any,
      widgetCapture: WidgetCaptureConfig,
      widgetCountdown: WidgetCounterConfig,
      WidgetReservation: WidgetReservationConfig,
      widgetExtendedWeatherConfig: WidgetExtendedWeatherConfig,
      widgetOutfit: WidgetOutfitConfig,
      widgetVideocall: WidgetVideocallConfig,
      widgetOrderTicket: WidgetOrderTicketConfig,
      widgetReservationStatus: WidgetReservationStatusConfig,
    }
    type: string
  },
  position: {
    height: number,
    width: number,
  }
  _id: string
}
export type AvailableMedia = {
  mediaPath: string,
  _id: string,
  mediaType: string
}

export type Design = { layers: Layer[], childModules: Design[], parentDesign: string, _id: string }
export type Layer = { segments: Segment[] }
export type Segment = { elements: DesignElement[] }
export type PlayerWindow = {
  PentaError: any,
  playerConfig: any,
  config: {
    apikey: string,
    enterprise: string,
  }
  screenUtils: {
    resolve: (path: string, params: any, dataset?: any) => any
  },
  host: {
    design: string,
    getElement: () => Promise<DesignElement>,
    getAvailableMedia: () => Promise<[AvailableMedia]>
    getDesign: () => Promise<Design>
  },
  screenRender: any,
  rtcServer: any,
  consoleForwarder: any,
  datasetEmployee: any,
  datasetWeather: any,
  datasetRSSNews: any,
  datasetSocialNetwork: any,
  datasetInternalNews: any,
  datasetUserStatus: any,
  datasetRouterCalendar: any
}
// widget url
export type WidgetUrlConfig = {
  url: string
}

export type WidgetTotemButtonsStyle = {
  borderWidth?: number,
  borderColor?: string,
  borderRadius?: number,
  backgroundColor?: string,
  color?: string,
  textColor?: string,
  fontSize?: number,
  paddingVertical?: number,
  paddingHorizontal?: number,
  gap?: number,
  columns?: number
}



export type VueButtonStyle = CSSProperties

export type WidgetTotemTicketTemplates = {
  printTemplates?: Record<string, string>,
}

export type WidgetTotemAvatarConfig = {
  model?: string,
  background?: string,
}

export type WidgetTotemTransition = {
  type: 'FADE';
  direction: 'RIGHT' | 'LEFT' | 'BOTTOM' | 'TOP';
}

export type WidgetTotemConfig = {
  transition?: WidgetTotemTransition;
  style: BaseWidgetStyle & {
    fontSizeFactor: Number,
    queues: WidgetTotemButtonsStyle,
    buttons: WidgetTotemButtonsStyle,
    bgType?: 'IMAGE' | 'COLOR',
    paddingHorizontal?: number,
    paddingVertical?: number,
    borderRadius?: number,
  }
  requestIdentificationAtStart?: boolean,
  requireRegisteredClient?: boolean,
  requireRegisteredClientError?: string,
  print: boolean,
  imageId?: string, // ID de la imagen/logo para tickets (legacy, se migra a imageIds)
  imageIds?: string[], // IDs de las imágenes para tickets (hasta 2: logo + publicidad)
  allowFutureTurns?: boolean,
  idleTimeout: number,
  disableIfNoExecutive?: boolean,
  _extraData: {
    additionalMedia: AdditionalMedia
  },
  showFields?: {},
  texts?: {
    selectQueueText?: {
      enabled?: boolean,
      text?: string
    },
    turnCreatedSuccessText?: {
      enabled?: boolean,
      text?: string
    },
    noAvailabilityText?: {
      enabled?: boolean,
      text?: string
    },
    turnAnnouncedText?: {
      enabled?: boolean,
      text?: string
    },
    identificationPromptText?: {
      enabled?: boolean,
      text?: string
    },
    pleaseWaitText?: {
      enabled?: boolean,
      text?: string
    },
    phoneRequestQuestionText?: {
      enabled?: boolean,
      text?: string
    }
  }
  disableByCalendar?: boolean,
  hideDisabledMotives?: boolean,
  enableAvatar?: boolean,      // Habilita el avatar de voz (Tina) como interfaz principal
  avatarChatbotId?: string,    // _id del chatbot configurado para el avatar
  avatarActivationMode?: 'BUTTON' | 'AUTO', // Cómo se inicia la conversación con el avatar. Default 'BUTTON' si no está seteado
  avatarAutoActivation?: {
    minDwellMs?: number,       // Permanencia mínima frente a cámara antes de activar. Default 2000
    absenceTimeoutMs?: number, // Tiempo de ausencia de la persona activa antes de cerrar la conversación. Default 7000
  },
  ticketTemplates?: WidgetTotemTicketTemplates,
  requestPhoneNumber?: boolean,
}

export type WidgetTotemData = {
  router: Router,
  queueIdsWithExecutives: string[],
  avatarConfig?: WidgetTotemAvatarConfig,
  identificationNumberTypes?: string[], // tipos de documento habilitados por la empresa (Personalizar Empresa)
  socketConnected?: boolean, // Estado del socket del player al cargar; sin dato (mobile) se considera conectado
}


export type BaseWidgetStyle = {
  backgroundColor: string,
  bgImageId: string,
  textColor: string,
  fontId: string,
  fontSize?: number,
  boxShadow?: string,
  useBrandIdentity?: boolean // usa la identidad de la empresa (enterprise.brandIdentity), undefined = false
}

export type BaseWidgetConfig = {
  style: BaseWidgetStyle,
  _extraData: {
    additionalMedia: AdditionalMedia
  }
}

// RSS y News y Clock
export interface WidgetClockConfig extends BaseWidgetConfig {
  style: BaseWidgetStyle & {
    clockStyle: string,
    theme: string,
    clockColor: string,
    secondHandColor: string,
  }
  showFields: {
    date: boolean,
    hour: boolean,
    ubication: boolean
  },
  format: string,
  dateFormat: string,
  timeZone: {
    type: string,
    country: string,
    city: string,
    _utcOffset: string
  },
}

export interface SocialNetworkWidgetConfig extends BaseWidgetConfig {
  style: BaseWidgetStyle & {
    objectFit: string,
    highlightColor: string,
    autoScrollEnabled: boolean,
    imageSize: number,
    textAlign: string,
  },
  showFields: {
    mediaName: boolean,
    mediaPhoto: boolean,
    photo: boolean,
    description: boolean,
    ts: boolean,
  },
  pageSize: number,
  accounts: {
    alias: string,
    socialNetworkToken: string,
    provider: string,
    socialMediaInfo: SocialMediaInfo
  }[]
}
export interface RssWidgetConfig {
  style: BaseWidgetStyle & {
    objectFit: string,
    autoScrollEnabled: boolean,
    imageSize: number,
    textAlign: string,
  }
  showFields: {
    sourceName: boolean,
    photo: boolean,
    header: boolean,
    content: boolean,
    date: boolean,
  },
  _extraData: {
    additionalMedia: AdditionalMedia
  },
  pageSize: number,
  urls: { url: string }[]
  limit?: null | number,
}
export interface NewsWidgetConfig extends BaseWidgetConfig {
  showFields: {
    enterpriseName: boolean,
    photo: boolean,
    header: boolean,
    description: boolean,
    date: boolean,
  },
  routers: string[],
  groups: string[],
  style: BaseWidgetStyle & {
    categoryBGColor: string,
    categoryTitleColor: string,
    highlightColor: string,
    objectFit: string,
    autoScrollEnabled: boolean,
    imageSize: number,
    textAlign: string,
  },
  pageSize: number,
  showWithoutGroup?: boolean,
  limit?: null | number
}

export interface AnnounceConfig {
  enabled: boolean,
  duration: number,
  sound: string,
  // Factor que ajusta el tamaño de fuente que calcula automáticamente AnnouncementCard (1 = default, <1 achica, >1 agranda)
  fontSizeFactor?: number
}

export interface VoiceCallConfig {
  enabled: boolean,
  message: string,
}

export interface WidgetReservationConfig extends BaseWidgetConfig {
  style: BaseWidgetStyle & {
    gridType: string,
    theme: string,
    bgType: string,
    emphasisColor: string,
    emphasisAccent: string,
  },
  showFields: {
  },
  showStatus: string,
  gridModeParams: {
    column1: string,
    column1Name: string,
    column1Fallback?: string,
    column2: string,
    column2Name: string,
  },
  announce: AnnounceConfig,
  voiceCall: VoiceCallConfig,
  _extraData: {
    additionalMedia: AdditionalMedia,
    mediaSound: any
  },
  filters: {
    queues: WidgetQueueFilter[];
  },
}

export interface WidgetQueueFilter {
  queueId: string;
}

export interface WidgetReservationStatusConfig extends BaseWidgetConfig {
  style: BaseWidgetStyle & {
    theme: string,
    bgType: string,
    onTimeColor: string,
    dueSoonColor: string,
    overdueColor: string,
    noMetaColor: string,
    emphasisColor: string,
    showQueueSummary: boolean,
    showWaitingList: boolean,
    showAttendingList: boolean,
    routerPanel: {
      showQueueWaiting: boolean,
      showQueueMaxWaiting: boolean,
      showQueueWaitingMeta: boolean,
      showQueueAvgAttention: boolean,
      showQueueAttendingMeta: boolean,
    },
    waitingPanel: {
      showWaitingPersonName: boolean,
      showWaitingQueueName: boolean,
      showWaitingTime: boolean,
      showWaitingExtraInfo: boolean,
    },
    attendingPanel: {
      showAttendingCashBox: boolean,
      showAttendingPersonName: boolean,
      showAttendingQueueName: boolean,
      showAttendingTime: boolean,
      showAttendingExtraInfo: boolean,
    },
  },
  announce: AnnounceConfig,
  voiceCall: VoiceCallConfig,
  _extraData: {
    additionalMedia: AdditionalMedia,
    mediaSound: any
  },
  filters: {
    queues: WidgetQueueFilter[];
  },
}

export interface WidgetOrderTicketConfig extends BaseWidgetConfig {
  style: BaseWidgetStyle & {
    theme: string,
    bgType: string,
    showStatusLegend: boolean,
    showKeyboardHint: boolean,
    selectedColor: string,
  },
  statusColors: {
    waiting: { background: string, border: string },
    inProgress: { background: string, border: string },
    ready: { background: string, border: string },
    newBadge: { background: string, border: string },
  },
}

export interface OrderProduct {
  quantity: number,
  masterProduct?: string, // id del producto en datasetProduct; el dataset ORDER no trae el nombre, hay que resolverlo ahí
  name: string, // resuelto contra datasetProduct antes de llegar al componente
}

export interface OrderItem {
  _id: string,
  serial: string,
  client?: { name: string },
  products: OrderProduct[],
  queue: { status: string | null, ts: string },
  CALL: boolean,
  ts: string, // hora en la que se hizo el pedido
}

export interface WidgetInteractiveConfig extends BaseWidgetConfig {
  style: BaseWidgetStyle & {}
  showFields: {
    categoryName: boolean,
    title: boolean,
    description: boolean,
    address: boolean,
    additionalInfo: boolean,
    subCategoryMenu: boolean,
    image: boolean,
    seeMore: boolean,
  },
  _extraData: {
    additionalMedia: AdditionalMedia
  }
  categories: { category: string, color: string, icon: string, alias: string, index?: number }[],
  showMap: boolean,
  dataFrom: string,
  resourceId: string
}

export type InteractiveData = {
  category: string,
  color: string,
  icon: string,
  alias: string,
  index?: number,
  details: InteractiveDataDetail[]
}

export type InteractiveDataDetail = {
  subCategory: string,
  name: string,
  telephone?: string,
  schedule?: string,
  address?: string,
  url?: string,
  image?: string,
  additionalInfo?: string,
  description?: string,
  coords?: string
}

export interface WidgetDynamicContentConfig extends BaseWidgetConfig {
  resources: DynamicResource[]
}

export type DynamicResource = {
  type: string,
  name: string,
  relatedId: string,
  conditionGroupOperator: string,
  conditionGroups: DynamicContentConditionGroup[]
}

export type DynamicContentConditionGroup = {
  operator: string,
  conditions: Condition[]
}

export type Condition = {
  variable: string,
  value: string,
  condition: string,
  dateStart?: Date,
  dateEnd?: Date,
  hourStart?: number,
  hourEnd?: number,
  daysOfWeek?: number[],
  valueStart?: number,
  valueEnd?: number,
  queues?: string[],
}

export type WidgetCaptureConfig = {
  webUrl: string,
  captureInterval: number,
  userHeaders: Header[],
  style: {
    scale: number,
  }
}

export type Header = {
  key: string,
  value: string
}

export interface WidgetPowerBiConfig {
  powerBiUrl: string,
  style: {
    captureWidth: number,
    captureHeight: number,
    scale: number,
    boxShadow: string
  }
}

export type JSONPowerBiRes = {
  error: string,
  imgStatus: string,
  ts: string,
  url: string,
  hash?: string
}

type LastState = {
  userCredential?: string
  name?: string,
  email?: string,
  ts?: string
}

type InteractionsSummary = {
  comments: number,
  reactions: { reaction: string, count: number }[]
}

export type NewsItem = {
  content: string,
  title: string,
  date: string,
  image: string,
  newsUrl: string,
  sourceName: string,
  sourceLogo: string,
  enterpriseName: string,
  media?: PlayerItemMedia,
  _pageDuration?: number,
  _articleId?: number, // ID único para cada artículo, usado en el NewsHubWidget para el autoscroll del título
}

export interface InternalNewsItem extends NewsItem {
  posArea: any,
  tags: any,
  description: string,
  enterpriseName: string,
  published: boolean,
  enterpriseImage: string,
  sortIndex?: number,
  routers?: string[],
  groups?: string[],
  link?: string,
  interactionsSummary?: InteractionsSummary,
  lastState?: LastState,
  cacheMediaPath?: string,
  _categories?: string[],
  _interaction?: any,
  _id?: string,
  _internalNewImage?: { media: PlayerItemMedia },
  _enterpriseLogo?: PlayerItemMedia & {
    image: string,
    media: string
  },
  _pageDuration?: number,
  deleted?: boolean,
  dataOrigin?: string // 'MOCK' en las noticias de prueba del preview de mobile (widget.factory.js → getMockData)
}

export interface ReservationItem {
  _id: string,
  name: string,
  queue: Queue
  origin: string
  posArea: null
  serial: string
  enterprise: string
  cashBox?: Cashbox
  queueStatus?: string //estado del turno, no existe cuando el turno es programado y no está anunciado ni llamado
  relatedId: string
  serialFixed: boolean
  CALL?: boolean // flag transitorio calculado por el player (trackVisibility en datasetReservation.js) cuando cambia queueTS; no es un campo del modelo, no llega fuera del player
  date: Date, // existe siempre, no confiar en este campo, es la fecha a la que estaba programado el turno pero en un momento cambiar
  ts: number // registra la fecha del ultimo cambio hecho en la reserva (si lo finalizaste, lo atendiste, etc)
  attendedTS?: Date // Ultima fecha en que fue llamado a atención
  attendingTS?: Date // fecha colocada por el player, no existe en el modelo
  oldQueueTS?: Date | undefined // fecha colocada por el player, no existe en el modelo
  queueTS?: Date  // fecha usada en el player, no en barra ejecutiva
  videocallRoomId?: string
  dataOrigin?: string
  identificationNumber?: string
  identificationType?: string
  additionalInformation?: string
}

export type MappedReservationItem = {
  _id: string
  serial: string
  name: string
  client: string
  identificationNumber?: string
  additionalInformation?: any
  reason?: string
  cashBox?: string
  queueStatus?: string
  attendedTS?: Date
  isCalled?: boolean
  dataOrigin?: string
  identificationType?: string
}

type Cashbox = {
  _id: string,
  name: string
}
// Users
export interface UsersWidgetConfig extends BaseWidgetConfig {
  style: BaseWidgetStyle & {
    dateType: string,
    dateBorderColor: string,
    dateBgColor: string,
    usersPerPageType?: 'AUTO' | 'CUSTOM', // AUTO: entran los que permite el alto; CUSTOM: usa usersPerPage
    usersPerPage?: number
  },
  type: string,
  showFields: {
    userName: boolean,
    date: boolean,
    profileImage: boolean,
    userPosArea: boolean,
    jobPositions: boolean
  },
  dataFrom: {},
  resourceId: string,
  dateRange: string,
  showSince?: string,
  selectByRouter?: string,
  routers?: [{ _id: string, name: string }],
  posAreas?: [{ _id: string, name: string }],
  integrations?: {
    buk?: {
      matchCompanies?: { bukCompanyId: string, bukCompanyName: string, woxiRouterId: string }[]
    }
  },
}

type SocialMediaInfo = {
  title: string, // titulo del perfil de ig, cuando viene de rssapp
  description: string, //descripcion del perfil de ig, cuando viene de rssapp
  source_url: string,
  media: PlayerItemMedia, //esto lo agrega el dataset si existe un file para descargar
}

export type LinkedSocialNetwork = {
  provider: string,
  socialNetworkToken: string,
  socialMediaInfo: SocialMediaInfo,
  alias: string,
  crc: string,
  mediaType: string,
  _iconUrl: string //esto no pertenece al modelo
  media: PlayerItemMedia
}

export type PlayerItemMedia = {
  _id: string,
  crc: string,
  mediaType: string
}

export type SocialNetworkItem = {
  title: string,
  description: string,
  mediaUrl: string,
  mediaType: string,
  likes: number,
  externalId: string,
  ts: string,
  socialNetworkToken: string,
  linkedSocialNetwork: string,
  _linkedSocialNetworkDetail?: LinkedSocialNetwork,
  media: PlayerItemMedia,
  comments: [{
    text: string,
    from: string,
    ts: string
  }],
  _pageDuration?: number,
  _articleId?: number, // ID único para cada artículo, usado en el NewsHubWidget para el autoscroll del título
}

export type JobPosition = { _id: string, name: string, enterprise: string }

export type User = {
  userCredential: { _id: string, posAreas: PosAreas[], routers: Routers[], type: string },
  userProfile: { name: string, birthdayMD: string, jobPosition: string, image: string, employeeStartDate: string, employeeStartDateMD: string }
}

export type PosAreas = { _id: string, name: string, enterprise: string }
export type Routers = { _id: string, name: string, enterprise: string }

export type UsersItem = {
  name: string,
  image: string | undefined, // url de la imagen
  birthdayMD: string | undefined,
  routers: Router[],
  jobPosition: string | undefined, // no es un id, es el nombre real del puesto
  posAreas: PosArea[],
  type: string, //si es "ADMINISTRATOR"/"BRANCH-MANAGER"/"EMPLOYEE"
  userCredential: string, // userCredential ID
  employeeStartDateMD: string,
  employeeStartDate: string,
}
export type PosArea = { _id: string, name: string, enterprise: string }

// Dataset
type UserDatasetPosArea = {
  _id: string,
  name: string,
}

type UserDatasetRouter = {
  _id: string,
  name: string,
}

type UserDatasetJobPosition = {
  _id: string,
  name: string,
}

export type DatasetUserObject = {
  birthday: string | undefined,
  email: string,
  name: string,
  posAreas: PosArea[];
  relatedId: string,
  routers: string[],
  status: unknown,
  ts: string,
  userCredential: string,
  _id: string,
  jobPosition: UserDatasetJobPosition,
  image: { _id: string },
  media: any // TODO: Es un objeto que se forma en la función getItemMedia en datasetEmployee, se podría tipar sin mucho problema pero lo dejo por el momento.
  _birthday: string | undefined,
  employeeStartDate: string,
  type: string,
}

export type Theme = {
  backgroundColor?: string
  textColor?: string
  dividerVerticalBorderColor?: string
  dividerHorizontalBorderColor?: string
}

// Weather
export type Geolocalization = {
  type: string
  coordinates: number[]
}

export type LocationDataConfig = {
  locationId: string
  address?: string
  country?: string
  city?: string
  geolocalization?: Geolocalization
}

export type WeatherTransition = {
  type: 'FADE'
  direction: 'RIGHT' | 'LEFT' | 'BOTTOM' | 'TOP'
}

export type WeatherStyle = {
  useBrandIdentity?: boolean; // usa la identidad de la empresa (enterprise.brandIdentity), undefined = false
  view: 'VERTICAL' | 'SQUARE' | 'CARD' | 'ROW';
  theme: 'LIGHT' | 'DARK' | 'CUSTOM';
  iconPack: 'LINEA' | 'MINIMALIST';
  icons: string;
  fontId?: string;
  fontSize?: number;
  boxShadow?: string;
  backgroundColor: string;
  textColor: string;
  limitDays?: number //para clima extendido
  format?: string //para clima extendido
}

export type WeatherShowFields = {
  date: boolean;
  city: boolean;
  temperature: boolean;
  weatherIcon: boolean;
  minimumMximum: boolean;
  weatherState: boolean;
  precipitation: boolean;
  uv: boolean;
}
export interface WeatherWidgetConfig {
  mode: 'AUTOMATIC' | 'MANUAL';
  locationData: LocationDataConfig;
  temp: 'C' | 'F';
  transition: WeatherTransition;
  style: WeatherStyle;
  showFields: WeatherShowFields,
  _extraData: {
    additionalMedia: AdditionalMedia
  }
}

export type LocationDataItem = {
  city?: string,
  fullName?: string,
  elevationC?: string,
  elevationF?: string,
  latitude?: number,
  localDate: string,
  localEpoch?: number,
  locationID?: string,
  longitude?: number,
}

export type WeatherOneDay = {
  location: LocationDataItem
  forecast: [],
  ts: string
}
export interface WeatherItem {
  fourDays: WeatherOneDay | {}
  oneDay: WeatherOneDay | {}
}

export interface WidgetCounterConfig {
  style: BaseWidgetStyle & {
    counterStyle: string,
    theme: string,
    counterColor: string,
    counterTextColor: string,
    counterBackgroundColor: string,
    backgroundType: string,
    iconsColor: string,
    highlightTextColor: string,
    objectFit: 'cover' | 'contain' | 'fill'
  },
  showFields: {
    date: boolean,
    hour: boolean,
    image: boolean,
    previousText: boolean,
    finalText: boolean
  },
  countType: 'COUNTDOWN' | 'COUNTUP',
  date: string,
  finalMessage: string,
  imageId: string,
  previousText: string,
  finalText: string,
  timeFormat: string,
  _extraData: {
    additionalMedia: AdditionalMedia
  }
}

export interface WidgetOutfitConfig {
  generateQRCode?: boolean,
  style: BaseWidgetStyle & {
    theme: string
  },
  showFields: {
    companyLogo: boolean,
    lastPhoto: boolean,
    downloadQR: boolean,
    footerText: boolean
  },
  footerText: string,
  loadType: string,
  outfits: OutfitSet[],
  customPrompt?: string,
  customPromptImageIds?: string[],
  _extraData: {
    additionalMedia: AdditionalMedia
  }
}

export type OutfitSet = {
  index: number,
  name: string,
  outfitImageId: string,
  backgroundImageId?: string,
  poseImageId?: string,
  accessoryImageIds?: string[]
}

export interface WidgetVideocallConfig extends BaseWidgetConfig {
  useAvatar?: boolean,
  chatbot?: string,
  previewRouterId?: string, // Sucursal para probar la derivación del avatar en la vista previa del modal (se ignora en la terminal, que usa su propia sucursal)
  queueId: string,
  style: BaseWidgetStyle & {
    fontSize?: number,
    position?: 'TOP_LEFT' | 'TOP_CENTER' | 'TOP_RIGHT' | 'CENTER_LEFT' | 'CENTER' | 'CENTER_RIGHT' | 'BOTTOM_LEFT' | 'BOTTOM_CENTER' | 'BOTTOM_RIGHT', // Posición del botón dentro del widget
    bgType?: 'COLOR' | 'IMAGE',
    bgImageId?: string,
    backgroundColor?: string,
    button: {
      backgroundColor?: string,
      textColor?: string
    }
  },
  texts: {
    callButtonText?: {
      enabled?: boolean,
      text?: string
    }
  },
  _extraData: {
    additionalMedia: AdditionalMedia
  }
}

export type WidgetVideocallData = {
  routerId: string | null,
  terminalId: string | null,
  availableQueues: Queue[],
  reservations: ReservationItem[]
}

export type IconPacks = {
  LINEA?: string;
  MINIMALIST?: string;
};

declare global {
  interface Window extends PlayerWindow { }
}

/// clima extendido
export interface WidgetExtendedWeatherConfig extends WeatherWidgetConfig {
  format: string
}
/// fin clima extendido
/////////////

export function getWidgetHeight(targetElement: Element | null = null) {
  let parentElement
  if (!targetElement) parentElement = document.body
  else parentElement = targetElement
  const tempDiv = document.createElement('div')
  tempDiv.style.position = "fixed";
  tempDiv.style.width = "100%";
  tempDiv.style.height = "100%";
  parentElement.appendChild(tempDiv)
  const pixelHeight = tempDiv.offsetHeight
  parentElement.removeChild(tempDiv)
  return pixelHeight
}

export async function getDesignElement(): Promise<DesignElement> {
  const design: Design = await window.host.getDesign(); // canal que esta reproduciondo
  const availableMedia = await window.host.getAvailableMedia(); // data que se descargó, imagenes, fuentes, addons, etc

  const childModule = design.childModules.find(f => f._id === window.host.design)
  if (!childModule) throw new Error("No se encontro el addon")
  const layer = design.layers.find(layer => layer.segments.find(segment => segment.elements[0].designId === childModule.parentDesign))
  if (!layer) throw new Error("No se encontro el layer")
  const segment = layer.segments.find(segment => segment.elements[0].designId === childModule.parentDesign)
  if (!segment) throw new Error("No se encontro el segmento")
  const designElementAddon = segment.elements[0] // elemento que adentro contiene el addon que estoy reproduciendo

  if (designElementAddon.additionalMedia) for (const item of designElementAddon.additionalMedia) {
    const hostItem = availableMedia.find((f: AvailableMedia) => f._id === item._id && f.mediaType === item.mediaType)
    if (hostItem) Object.assign(item, hostItem);
  }
  return designElementAddon
}

function calculateScreenHeight(percentualHeight: number, elementHeight: number): number | undefined {
  if (!percentualHeight || !elementHeight) return;
  return (100 * elementHeight) / percentualHeight
}

export function getFontSize(percentualWidgetHeight?: number, pixelWidgetHeight?: number, percentualFontSize?: number) {
  if (!percentualWidgetHeight || !pixelWidgetHeight || !percentualFontSize) return "13px"

  const screenHeight = calculateScreenHeight(percentualWidgetHeight, pixelWidgetHeight)
  if (!screenHeight) return "13px"
  return Math.floor(screenHeight * (percentualFontSize / 100)) + 'px'
}

//Document es "any" porque Document como tipo no está en lib
export async function setFont(fontId: string, additionalMedia: any, document: any): Promise<void> {
  try {
    if (!additionalMedia?.length || !fontId) return
    let font = additionalMedia.find((data: any) => data.mediaType === 'TTF' && fontId === data._id)
    if (!font?.mediaPath) return
    let mediaPath = window.hostAdapter ? await window.hostAdapter.getlocalfile(font.mediaPath) : font.mediaPath;
    const fontFace = new FontFace(`${font._id}`, `url(${mediaPath}) format('truetype')`)
    document.fonts.add(fontFace);
  } catch (error) {
    console.error(error)
  }
}

export type BrandIdentity = { fontId?: string, colors?: { title?: string, primary?: string, secondary?: string } }
type BrandIdentitySource = 'font' | 'title' | 'primary' | 'secondary'

// Campos de style que cada widget toma de enterprise.brandIdentity cuando style.useBrandIdentity es true.
// Clave: nombre del widget en PascalCase (el mismo que recibe openWidget/openWidgetOnPlayer). Valor: path dentro de style -> dato de brandIdentity.
// Es la única fuente del mapeo: el modal de estilo (src/frontend/commons/modals/widgetStyle/) bloquea los campos usando applyBrandIdentity vía window.vue, no hace falta replicarlo
const usersBrandFields: Record<string, BrandIdentitySource> = { fontId: 'font', dateBorderColor: 'primary' }
const weatherBrandFields: Record<string, BrandIdentitySource> = { fontId: 'font', icons: 'primary' }
const brandIdentityStyleFields: Record<string, Record<string, BrandIdentitySource>> = {
  WidgetRss: { fontId: 'font', titleColor: 'title' },
  WidgetNews: { fontId: 'font', titleColor: 'title', categoryBGColor: 'primary' },
  WidgetUsers: usersBrandFields,
  WidgetSeniority: usersBrandFields,
  WidgetEntrance: usersBrandFields,
  WidgetClock: { fontId: 'font' },
  WidgetInteractive: { fontId: 'font' },
  WidgetWeather: weatherBrandFields,
  WidgetExtendedWeather: weatherBrandFields,
  WidgetSocialNetworks: { fontId: 'font' },
  WidgetCountdown: { fontId: 'font', highlightTextColor: 'primary' },
  WidgetTotem: { fontId: 'font', textColor: 'title', 'buttons.textColor': 'title', 'buttons.borderColor': 'primary', 'buttons.backgroundColor': 'secondary' },
  WidgetReservation: { fontId: 'font', emphasisColor: 'primary', emphasisAccent: 'secondary' },
  WidgetOrderTicket: { fontId: 'font', selectedColor: 'primary' },
}

// Devuelve la identidad visual de la empresa (enterprise.brandIdentity) según dónde corre el widget: config del player o profile de la web
export function getBrandIdentity(): BrandIdentity | undefined {
  // En el player viene en config.populatedEnterprise (GET-CONFIG en src/caster/caster.js)
  if (runningOnPlayer()) return window.player?.config?.populatedEnterprise?.brandIdentity
  return window.profile?.enterpriseBrandIdentity
}

// Devuelve una copia de la config con los campos de style pisados por la identidad de la empresa, si style.useBrandIdentity es true.
// Los datos que la empresa no tiene configurados no pisan lo del widget.
// widget: nombre del widget en PascalCase. config: configuración del widget (la que devuelve getConfig). brandIdentity: identidad de la empresa
export function applyBrandIdentity<Config>(widget: string, config: Config, brandIdentity: BrandIdentity | undefined = getBrandIdentity()): Config {
  const style = (config as any)?.style
  const fields = brandIdentityStyleFields[widget]
  if (!style?.useBrandIdentity || !fields || !brandIdentity) return config
  const brandStyle = Object.keys(fields).reduce((acc: any, path: string) => setStylePath(acc, path, getBrandIdentityValue(brandIdentity, fields[path])), style)
  return { ...config, style: brandStyle }
}

// Devuelve true si el widget puede tomar la identidad de la empresa (tiene campos en el mapeo).
// Es la única fuente de qué widgets son compatibles: la usa tvPlayerWidget.factory (vía window.vue) para activar la bandera en widgets nuevos y en canales desde plantilla
// widget: nombre del widget en PascalCase
export function isBrandIdentityWidget(widget: string): boolean {
  return !!brandIdentityStyleFields[widget]
}

// Envuelve el getConfig de un widget para que siempre devuelva la config con la identidad de la empresa aplicada
// widget: nombre del widget en PascalCase. getConfig: función original que obtiene la configuración
export function withBrandIdentity<Config>(widget: string, getConfig: (...args: any[]) => Promise<Config>): (...args: any[]) => Promise<Config> {
  return async (...args: any[]) => applyBrandIdentity(widget, await getConfig(...args))
}

// Devuelve el valor de brandIdentity correspondiente a un origen ('font' o un color), o undefined si no está configurado (los vacíos cuentan como no configurados)
function getBrandIdentityValue(brandIdentity: BrandIdentity | undefined, source: BrandIdentitySource): string | undefined {
  if (source === 'font') return brandIdentity?.fontId || undefined
  return brandIdentity?.colors?.[source] || undefined
}

// Devuelve una copia de style con el valor asignado en path (paths de hasta un nivel, ej 'buttons.textColor'). Si value es undefined devuelve style sin cambios
function setStylePath(style: any, path: string, value: string | undefined): any {
  if (value === undefined) return style
  const [key, subKey] = path.split('.')
  if (!subKey) return { ...style, [key]: value }
  return { ...style, [key]: { ...style[key], [subKey]: value } }
}

export function getBackgroundImgUrl(bgImageId: string, additionalMedia: any): string {
  if (!bgImageId) return ''
  let bgImage = additionalMedia.find((data: any) => data.mediaType === 'IMAGE' && bgImageId === data._id)
  if (!bgImage) return ''
  return bgImage.mediaPath ? bgImage.mediaPath : '';
}

// Resuelve announce.sound contra additionalMedia y deja el mediaPath local listo en config._extraData.mediaSound. Usado por cualquier wrapper de widget con announce/voiceCall (widgetReservation, widgetReservationStatus).
export async function resolveAnnounceSound(config: any): Promise<void> {
  if (!config.announce?.sound || !config._extraData) return
  const soundIndex = config._extraData.additionalMedia.findIndex((f: any) => f.mediaType === 'VIDEO' && f._id === config.announce?.sound)
  if (soundIndex < 0) return
  config._extraData.additionalMedia[soundIndex].mediaPath = await window.hostAdapter.getlocalfile(window.hostAdapter.mediaPath(config._extraData.additionalMedia[soundIndex]))
  config._extraData.mediaSound = config._extraData.additionalMedia[soundIndex]
}

export function getWidgetPadding(height: number, showCategory: boolean): string {
  if (showCategory) return '0.6em 1.2em';
  return height < 100 ? '0.6em 1.2em' : '1.2em'
}

// Guarda los datos en localStorage
export function setStoredData(type: string, data: any) {
  try {
    let jsonData = JSON.stringify(data)
    let mbLimit = MBLimitReached(jsonData)
    if (isNaN(mbLimit) || mbLimit > 4) throw new Error(`Los datos superan los 4mb. No se guardaran en caché ni actualizará. Request: ${type}. Tamaño: ${mbLimit}`)
    let dataToStore = JSON.stringify({ data: data, ts: Date.now(), size: mbLimit })
    localStorage.setItem(type, dataToStore)
    localStorage.setItem(`${type}_pending`, 'false')
  } catch (error) {
    console.error(error)
  }
}

// devuelve la cant de mb que tiene el dato en string
function MBLimitReached(data: string): number {
  let bytes = (new TextEncoder().encode(data)).length
  let megabytes = bytes / (1024 * 1024);
  return megabytes;
}

export async function getStoredData(type: string, time = 60): Promise<any> {
  if (isNaN(time)) time = 60
  if (!type) throw new Error('No se especificó un tipo de datos a buscar en storage')
  let pending = localStorage.getItem(`${type}_pending`)
  if (pending === 'true') await waitForStoredData(type)
  let localData = JSON.parse(localStorage.getItem(type) as string)
  let cacheTimeExceeded = Date.now() - localData?.ts > (1 * time * 60 * 1000); //pasó 1 hora desde la ultima vez que hice un request

  let needRequest = !localData || cacheTimeExceeded
  if (needRequest) localStorage.setItem(`${type}_pending`, 'true')

  return { needRequest: needRequest, data: localData?.data }
}

function waitForStoredData(type: string, count = 0, originalResolve?: any | undefined, originalReject?: any | undefined): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!originalResolve) originalResolve = resolve
    if (!originalReject) originalReject = reject
    try {
      if (count > 5) return originalResolve() //se resuelve sin datos
      let pending = localStorage.getItem(`${type}_pending`)
      if (pending !== 'true') return originalResolve() //se resuelve con datos ya guardados
      else setTimeout(() => waitForStoredData(type, count + 1, originalResolve, originalReject), 800)
    } catch (error) {
      originalReject(error)
    }
  })
}

function runningOnPlayer(): boolean {
  return !!window.player
}

export function localUrlToStatic(url: string): string {
  return runningOnPlayer() ? window.path.local('widgets' + url) : url
}

export function urlToStatic(url: string): string {
  return runningOnPlayer() ? window.path.remote(url) : url
}

function externalUrl(item: any, mediaPath: string, cacheMediaPath: string) {
  return runningOnPlayer() ? item[cacheMediaPath] : item[mediaPath]
}

(window as any).widgetUtils = moduleExport
export default moduleExport

function formatColorLinks(text: string, highlight: string, widgetOrigin: string): string {
  const regex = /(@[\w.-]+|#[\w.-]+|(?:https?:\/\/|www\.)[a-zA-Z0-9.-]+(?:\/[^\s]*)?)/g;
  const highlightColor = highlight || '#5B91F4'

  const safeText = text || ''

  return safeText.replace(regex, (match) => {
    // Si es un enlace y no esoty en el player
    if ((match.startsWith('http') || match.startsWith('www')) && widgetOrigin === 'MURAL-APP') {
      if (match.startsWith('www')) match = 'https://' + match
      return `<a href="${match}" style="color: ${highlightColor}" target="_blank" rel="noopener noreferrer">${match}</a>`;
    }
    return `<span style="color: ${highlightColor}">${match}</span>`;
  });
}

// Extrae la versión del WebView del userAgent. Devuelve un número con la versión o null si no se encuentra.
// Es como se encuentra en terminalUtils.js
export function getWebViewVersion(): number | null {
  const regexpWebView = /(\d+\.\d+)\.\d+\.\d+/
  const userAgent = navigator.userAgent;
  const webViewVersion = regexpWebView.exec(userAgent)
  return webViewVersion ? parseFloat(webViewVersion[1]) : null;
}

// Calcula la cantidad de slides a mostrar según la configuración y la cantidad de elementos en el array
export function getSlideQuantity(array: any[], configSize: number | undefined | null): number {
  if (!array || array.length === 0) return 0; //nada que mostrar
  const DEFAULT_PAGE_SIZE = 50;

  // Si por alguna casuzalidad no hay ninguna configuración de cuantos elementos mostrar, usamos el valor por defecto
  const limit = configSize ?? DEFAULT_PAGE_SIZE;

  // Siempre mostramos la menor cantidad entre:
  // - lo que tiene el array
  // - el límite definido (por config o por defecto)
  return Math.min(array.length, limit);
}

// esta funcion calcula cuanto debe durar el markee para que la noticia se lea apropiadamente
// de lo contrario, la animación se hace muy rapido o muy lento dependiendo de la cantidad de texto
export function getMarqueePageDuration(description: string, title?: string): number {
  if (!description) return 10;
  if (title) description = title + ' ' + description
  const words = description.split(' ').length;
  const wordsPerSecond = 3; // Ajusta este valor según la velocidad de lectura deseada
  return (words / wordsPerSecond) + SCROLL_DELAY // segundos
}
